(() => {
  if (window.StorefrontVisualSelectorsInitialized) return;
  window.StorefrontVisualSelectorsInitialized = true;

  const closeSelector = (selector) => {
    if (!selector) return;

    const trigger = selector.querySelector('[data-selector-trigger]');
    const panel = selector.querySelector('[data-selector-panel]');

    selector.classList.remove('is-open');
    if (trigger) trigger.setAttribute('aria-expanded', 'false');
    if (panel) panel.hidden = true;
  };

  const openSelector = (selector) => {
    const wrapper = selector.closest('[data-storefront-visual-selectors]');
    if (!wrapper) return;

    wrapper.querySelectorAll('[data-selector]').forEach((item) => {
      if (item !== selector) closeSelector(item);
    });

    const trigger = selector.querySelector('[data-selector-trigger]');
    const panel = selector.querySelector('[data-selector-panel]');

    selector.classList.add('is-open');
    if (trigger) trigger.setAttribute('aria-expanded', 'true');
    if (panel) panel.hidden = false;
  };

  document.querySelectorAll('[data-storefront-visual-selectors]').forEach((wrapper) => {
    wrapper.querySelectorAll('[data-selector]').forEach((selector) => {
      const trigger = selector.querySelector('[data-selector-trigger]');
      const options = Array.from(selector.querySelectorAll('[data-selector-option]'));
      const input = selector.querySelector('[data-selector-input]');
      const form = selector.querySelector('form');

      if (!trigger || !options.length || !input || !form) return;

      trigger.addEventListener('click', () => {
        if (selector.classList.contains('is-open')) {
          closeSelector(selector);
          return;
        }

        openSelector(selector);
      });

      selector.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
          closeSelector(selector);
          trigger.focus();
          return;
        }

        if (!selector.classList.contains('is-open')) return;

        const activeIndex = options.findIndex((option) => option === document.activeElement);

        if (event.key === 'ArrowDown') {
          event.preventDefault();
          const nextIndex = activeIndex === -1 ? 0 : (activeIndex + 1) % options.length;
          options[nextIndex].focus();
        }

        if (event.key === 'ArrowUp') {
          event.preventDefault();
          const previousIndex = activeIndex === -1 ? options.length - 1 : (activeIndex - 1 + options.length) % options.length;
          options[previousIndex].focus();
        }
      });

      options.forEach((option) => {
        option.addEventListener('click', () => {
          const nextValue = option.dataset.value || '';
          if (!nextValue) return;

          if (input.value === nextValue) {
            closeSelector(selector);
            trigger.focus();
            return;
          }

          input.value = nextValue;

          if (typeof form.requestSubmit === 'function') {
            form.requestSubmit();
          } else {
            form.submit();
          }
        });
      });
    });
  });

  document.addEventListener('click', (event) => {
    document.querySelectorAll('[data-storefront-visual-selectors] [data-selector]').forEach((selector) => {
      if (!selector.contains(event.target)) closeSelector(selector);
    });
  });
})();
